// Capture drag items immediately and pass files to the existing queue as they become available.
export const importDroppedFiles = (
    dataTransfer: DataTransfer,
    onFiles: (files: File[]) => void,
    onError: (error: unknown) => void = console.error,
): void => {
    const sources = Array.from(dataTransfer.items || [])
        .filter(item => item.kind === 'file')
        .map(item => ({
            entry: typeof item.webkitGetAsEntry === 'function' ? item.webkitGetAsEntry() : null,
            file: item.getAsFile(),
        }))
    const fallbackFiles = Array.from(dataTransfer.files)
    const hasFolders = sources.some(source => source.entry?.isDirectory)
    const looseFiles = hasFolders || !fallbackFiles.length
        ? sources.filter(source => !source.entry?.isDirectory && source.file).map(source => source.file!)
        : fallbackFiles

    // Ordinary file drops stay synchronous and use the original File objects.
    if (looseFiles.length) onFiles(looseFiles)

    function readEntry(entry: FileSystemEntry): void {
        if (entry.isFile) {
            try {
                (entry as FileSystemFileEntry).file(file => onFiles([file]), onError)
            } catch (error) {
                onError(error)
            }
        } else if (entry.isDirectory) {
            try {
                const reader = (entry as FileSystemDirectoryEntry).createReader()
                function readBatch(): void {
                    try {
                        reader.readEntries(entries => {
                            if (!entries.length) return
                            entries.forEach(readEntry)
                            readBatch()
                        }, onError)
                    } catch (error) {
                        onError(error)
                    }
                }
                readBatch()
            } catch (error) {
                onError(error)
            }
        }
    }

    sources.forEach(source => {
        if (source.entry && (source.entry.isDirectory || (!source.file && (hasFolders || !fallbackFiles.length)))) {
            readEntry(source.entry)
        }
    })
}
